var map = {
	"./en/fields.json": "e417",
	"./en/placeholders.json": "8ced",
	"./en/validations.json": "cec9",
	"./es/fields.json": "a574",
	"./es/placeholders.json": "f0e9",
	"./es/validations.json": "0e1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";